<template>
  <div v-once>
    <header class="section row align-middle">
      <div class="columns small-12 medium-6 large-6">
        <h1>School Fonts</h1>
        <p class="text-big">
          Teach Starter supports a wide range of school fonts, including United States, United
          Kingdom, Australia and New Zealand fonts.
        </p>
      </div>
    </header>

    <section class="section row align-middle">
      <div class="columns small-12">
        <h2>Generic School Fonts</h2>
        <p>Sassoon Primary is our default resource font.</p>
        <ul class="no-list">
          <li>
            <h3>Sassoon Primary</h3>
          </li>
          <li>
            <h3>Comic Sans</h3>
          </li>
        </ul>
      </div>
    </section>

    <section class="section row align-middle">
      <div class="columns small-12">
        <h2>United States School Fonts</h2>
        <p>
          The United States school font resources adhere to the correct US punctuation, spelling and
          grammar.
        </p>
        <ul class="row block-grid small-up-2">
          <li>
            <h3>Zaner-Bloser</h3>
            <ul>
              <li>Print</li>
              <li>Cursive</li>
              <li>Connect</li>
            </ul>
          </li>
          <li>
            <h3>D’Nealian</h3>
            <ul>
              <li>Print</li>
              <li>Cursive</li>
              <li>Connect</li>
            </ul>
          </li>
        </ul>
      </div>
    </section>

    <section class="section row align-middle">
      <div class="columns small-12">
        <h2>United Kingdom School Fonts</h2>
        <p>
          The United Kingdom school font resources adhere to the correct UK punctuation, spelling
          and grammar.
        </p>
        <ul class="row block-grid small-up-2">
          <li>
            <h3>Jarman</h3>
          </li>
        </ul>
      </div>
    </section>

    <section class="section row align-middle">
      <div class="columns small-12">
        <h2>Australian School Fonts</h2>
        <p>
          Australia has one of the most complex font systems. Almost every state has a different
          school font. We have sourced our fonts from
          <a href="https://www.australianschoolfonts.com.au/" target="_blank" rel="noopener">
            Australian School Fonts
          </a>
          , ensuring that all lettershapes, slants and joining rules comply precisely and fully with
          the latest official Education Department syllabus for each region
        </p>

        <p>
          The Australian school font resources adhere to the correct Australian punctuation,
          spelling and grammar.
        </p>

        <ul class="row block-grid small-up-2">
          <li>
            <h3>New South Wales</h3>
            <p>New South Wales school fonts are also used in the Australian Capital Territory.</p>
            <ul>
              <li>Print</li>
              <li>Cursive</li>
            </ul>
          </li>
          <li>
            <h3>Victoria</h3>
            <p>Victoria school fonts are also used in Western Australia and Northern Territory.</p>
            <ul>
              <li>Print</li>
              <li>Cursive (Vic Modern Cursive)</li>
            </ul>
          </li>
          <li>
            <h3>Queensland</h3>
            <ul>
              <li>Print (QBeginners)</li>
              <li>Precursive</li>
              <li>Cursive (QCursive)</li>
            </ul>
          </li>
          <li>
            <h3>South Australia</h3>
            <ul>
              <li>Print (SA Modern Print)</li>
              <li>Precursive</li>
              <li>Cursive (SA Modern Cursive)</li>
            </ul>
          </li>
          <li>
            <h3>Tasmania school fonts</h3>
            <ul>
              <li>Print (TAS Beginners)</li>
              <li>Precursive</li>
              <li>Cursive</li>
            </ul>
          </li>
        </ul>
      </div>
    </section>

    <section class="section row align-middle">
      <div class="columns small-12">
        <h2>New Zealand</h2>
        <p>
          The New Zealand school font resources adhere to the correct New Zealand punctuation,
          spelling and grammar.
        </p>
        <ul class="row block-grid small-up-2">
          <li>
            <h3>New Zealand</h3>
            <ul>
              <li>Print</li>
              <li>Precursive</li>
              <li>Cursive</li>
            </ul>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'SchoolFonts',
  data() {
    return {
      title: 'School Fonts',
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title },
        { hid: 'description', name: 'description', content: 'Login to your Teach Starter account' },
      ],
      link: this.$hrefLangsPage(this.$route),
    };
  },
};
</script>

<style scoped lang="scss">
.block-grid > * {
  padding-bottom: $base-padding * 2;
}
</style>
